import * as React from "react";
const SvgAddNew = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Icon" }, /* @__PURE__ */ React.createElement("path", { id: "icon", d: "M16.6666 10.8333H10.8333V16.6666H9.16665V10.8333H3.33331V9.16658H9.16665V3.33325H10.8333V9.16658H16.6666V10.8333Z" })));
export default SvgAddNew;
